/* eslint-disable @typescript-eslint/no-explicit-any */

import { FormProps } from '@rjsf/core';
import Form from '@rjsf/shadcn';
import { RJSFSchema } from '@rjsf/utils';
import ShAddButton from './ButtonTemplates/ShAddButton';
import { ShMoveDownButton } from './ButtonTemplates/ShMoveDownButton';
import { ShMoveUpButtom } from './ButtonTemplates/ShMoveUpButton';
import { ShRemoveButton } from './ButtonTemplates/ShRemoveButton';
import { ShFileObjectField } from './Fields/ShFileObjectField';
import { ShArrayFieldItemTemplate } from './Templates/ShArrayFieldItemTemplate';
import { ShArrayFieldTemplate } from './Templates/ShArrayFieldTemplate';
import { ShBaseInputTemplate } from './Templates/ShBaseInputTemplate';
import { ShDescriptionFieldTemplate } from './Templates/ShDescriptionFieldTemplate';
import { ShFieldTemplate } from './Templates/ShFieldTemplate';
import { ShObjectFieldTemplate } from './Templates/ShObjectFieldTemplate';
import { ShDateTimeWidget } from './Widgets/ShDateTimeWidget';
import { ShTextareaWidget } from './Widgets/ShTextareaWidget';

export const ShForm: React.FC<
  FormProps<any, RJSFSchema, any> & {
    startIndentLevel?: number;
    layoutClassNames?: {
      [key: number]: string;
    };
  }
> = (props) => {
  return (
    <Form
      {...props}
      widgets={{
        DateTimeWidget: ShDateTimeWidget({ defaultNow: true }),
        TextareaWidget: ShTextareaWidget,
      }}
      fields={{
        fileObject: ShFileObjectField,
        ...props.fields,
      }}
      templates={{
        ButtonTemplates: {
          RemoveButton: ShRemoveButton,
          MoveUpButton: ShMoveUpButtom,
          MoveDownButton: ShMoveDownButton,
          AddButton: ShAddButton,
        },
        BaseInputTemplate: ShBaseInputTemplate,
        FieldTemplate: ShFieldTemplate,
        ObjectFieldTemplate: ShObjectFieldTemplate({
          startIndentLevel: props.startIndentLevel,
          layoutClassNames: props.layoutClassNames,
        }),
        ArrayFieldTemplate: ShArrayFieldTemplate,
        ArrayFieldItemTemplate: ShArrayFieldItemTemplate,
        DescriptionFieldTemplate: ShDescriptionFieldTemplate,
        ...props.templates,
      }}
    />
  );
};
